// src/bootstrapAuth.js
import "./setupAuthedFetch";
import { getAuthToken } from "./authToken";

// Resolve API base once and strip trailing slashes
const RAW_BASE =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_BACKEND_URL) ||
  (window.__ENV__ && window.__ENV__.BACKEND_URL) ||
  "";
const API_BASE = (RAW_BASE || "").replace(/\/+$/, "");

/** true if the URL targets our API base */
function isApiUrl(u) {
  try {
    const full = new URL(u, window.location.origin).href;
    if (API_BASE) {
      return full === API_BASE || full.startsWith(API_BASE + "/");
    }
    // Fallback: treat same-origin as API when API_BASE isn't configured
    return new URL(full).origin === window.location.origin;
  } catch {
    return false;
  }
}

/** Merge headers and set Authorization when token present */
function mergeHeaders(existing, token) {
  const h = new Headers(existing || undefined);
  if (token) h.set("Authorization", `Bearer ${token}`);
  return h;
}

/** Best-effort cookie mirror for subdomain auth (when LS already has a token) */
(function ensureCookieMirror() {
  try {
    const lsToken = localStorage.getItem("token");
    const onProdHost = /(?:^|\.)backlinkbanana\.com$/i.test(window.location.hostname);
    const hasCookie = document.cookie.includes("bbtoken=");
    if (lsToken && onProdHost && !hasCookie) {
      document.cookie = `bbtoken=${encodeURIComponent(lsToken)}; Path=/; Domain=.backlinkbanana.com; Secure; SameSite=Lax; Max-Age=2592000`;
    }
  } catch {
    // ignore storage errors
  }
})();

if (!window.__AUTH_PATCHED__) {
  window.__AUTH_PATCHED__ = true;

  // ---- Patch fetch ----
  const nativeFetch = window.fetch.bind(window);

  window.fetch = (input, init = {}) => {
    const url =
      input instanceof Request
        ? input.url
        : input && input.href
        ? input.href
        : typeof input === "string"
        ? input
        : "";

    if (url && isApiUrl(url)) {
      const token = getAuthToken();
      const headers = mergeHeaders(
        init.headers || (input instanceof Request ? input.headers : undefined),
        token
      );

      // Include cookies so bbtoken can be used as fallback on subdomain
      const finalInit = { ...init, headers };
      if (!finalInit.credentials) finalInit.credentials = "include";

      if (input instanceof Request) {
        // Rebuild to apply new headers/credentials even when original was a Request
        const req = new Request(input, finalInit);
        return nativeFetch(req);
      }
      return nativeFetch(url, finalInit);
    }

    return nativeFetch(input, init);
  };

  // ---- Patch axios (if present) ----
  if (window.axios?.interceptors?.request) {
    window.axios.interceptors.request.use((cfg) => {
      const full = new URL(
        cfg.url || "",
        cfg.baseURL || window.location.origin
      ).href;
      if (isApiUrl(full)) {
        const t = getAuthToken();
        cfg.headers = { ...(cfg.headers || {}) };
        if (t) cfg.headers.Authorization = `Bearer ${t}`;
        cfg.withCredentials = true; // allow cookie fallback
      }
      return cfg;
    });
  }
}
